var DB_gallery_3_columns = {
    init:function(){

        var _swiper_container = document.querySelector(".DB-gallery-3-columns .swiper-container");

        var swiper = new Swiper(_swiper_container, {
            slidesPerView: 1,
            spaceBetween: 50,
            
            navigation: {
                nextEl: _swiper_container.querySelector(".swiper-button-next"),
                prevEl: _swiper_container.querySelector(".swiper-button-prev"),
              },
            pagination: {
              el: _swiper_container.querySelector(".swiper-pagination"),
              clickable:true
            },
           
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              1200: {
                slidesPerView: 3
              }
            },
          });
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-gallery-3-columns").length > 0){
        DB_gallery_3_columns.init();
    }
})